'use client'
import { useState, useEffect } from 'react'
import { useTorContext } from 'utils/context'
import TableDropdown from 'components/TableDropdown'
import { publicGetRequest } from 'services/one'
import { usePathname } from 'next/navigation'

const Coachs = () => {
  const { tor } = useTorContext()
  const [coachs, setCoachs] = useState()
  const pathname = usePathname()
  const showMsg = pathname.match(/\/(\d{4})\//)[1] === '2025'

  const getList = async () => {
    const list = await publicGetRequest({
      id: tor.Info.Id,
      endpoint: 'COACH_LIST'
    })
    setCoachs(list.Coachs)
  }

  useEffect(() => {
    getList()
  }, [])

  return (
    <div className="max-w-3xl mx-auto">
      {coachs &&
        coachs.map((coach, idx) => (
          <div key={idx} className="mt-10">
            <TableDropdown
              title={`${coach.name}  - ${coach.license}`}
              headers={['Nº Llicència', 'Jugadors/es']}
              content={coach.registered.map((player) => ({
                0: player.license,
                1: player.name
              }))}
              cols={2}
            />
          </div>
        ))}
      {showMsg && (
        <div className="mt-8">
          <p>
            La inscripció dels coach és anual i es pot realitzar abans del
            tancament de cadascuna de les proves de la FCP. Tots aquells tècnics
            que ja teniu sol·licitada l’acreditació anual no serà  necessari
            inscriure’s a cada prova on la FCP permet coaching.
          </p>
          <br />
          <p>
            Aquells tècnics que no heu sol·licitat l’acreditació anual ho podeu
            sol·licitar al correu esportiva@fcpadel.cat
          </p>
          <br />
          <p>
            Nota: una inscripció de coach no permet actuar com a tal en una
            determinada prova si s’ha produït i validat després del tancament
            d’inscripció de la mateixa.
          </p>
        </div>
      )}
    </div>
  )
}

export default Coachs
